export default __webpack_public_path__ + "static/media/banner-2.e792fe61.jpg";